import { render, staticRenderFns } from "./WalletTransactionsExport.vue?vue&type=template&id=5102723e&scoped=true"
import script from "./WalletTransactionsExport.vue?vue&type=script&lang=js"
export * from "./WalletTransactionsExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102723e",
  null
  
)

export default component.exports